import * as React from "react";
import { SvgComponentProps } from "utils/types/app";

const PinSvgComponent: React.FC<SvgComponentProps> = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8 8.666a2 2 0 100-4 2 2 0 000 4z"
        stroke="#D64B03"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 1.333a5.333 5.333 0 00-5.333 5.334c0 1.26.268 2.086 1 3l4.333 5 4.333-5c.732-.914 1-1.74 1-3A5.333 5.333 0 008 1.333z"
        stroke="#D64B03"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PinSvgComponent;
